import api from './api';

// Aula
const getClassroomByAcademicSetting = async (academicSettingId) => {
    try {
        const response = await api.get(`/classroom/academic-setting/${academicSettingId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getClassroom = async (classroomId) => {
    try {
        const response = await api.get(`/classroom/${classroomId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createClassroom = async (classroomData) => {
    try {
        const response = await api.post(`/classroom`, classroomData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateClassroom = async (classroomData) => {
    try {
        const response = await api.put(`/classroom`, classroomData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteClassroom = async (classroomId) => {
    try {
        const response = await api.delete(`/classroom/${classroomId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Intervalos. view: 'teacher' (default, ve todo) | 'student' (solo visibles)
const getIntervals = async (classroomId, view = 'teacher') => {
    try {
        const response = await api.get(`/classroom/${classroomId}/intervals?view=${view}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getInterval = async (intervalId) => {
    try {
        const response = await api.get(`/classroom/interval/${intervalId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createInterval = async (intervalData) => {
    try {
        const response = await api.post(`/classroom/interval`, intervalData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateInterval = async (intervalData) => {
    try {
        const response = await api.put(`/classroom/interval`, intervalData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Cambia únicamente isVisible (no reenvía el resto del intervalo) — usar
// siempre para el toggle de mostrar/ocultar en vez de updateInterval.
const setIntervalVisibility = async (intervalId, isVisible, modificationUser) => {
    try {
        const response = await api.put(`/classroom/interval/${intervalId}/visibility`, { isVisible, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// force=true confirma el borrado aunque el aula quede con menos del
// mínimo de intervalos sugerido (ver backend: responde warning=true si no).
const deleteInterval = async (intervalId, force = false) => {
    try {
        const response = await api.delete(`/classroom/interval/${intervalId}${force ? '?force=true' : ''}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Secciones. view: 'teacher' (default, ve todo) | 'student' (solo visibles)
const getSections = async (intervalId, view = 'teacher') => {
    try {
        const response = await api.get(`/classroom/interval/${intervalId}/sections?view=${view}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getSection = async (sectionId) => {
    try {
        const response = await api.get(`/classroom/section/${sectionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createSection = async (sectionData) => {
    try {
        const response = await api.post(`/classroom/section`, sectionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateSection = async (sectionData) => {
    try {
        const response = await api.put(`/classroom/section`, sectionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Cambia únicamente isVisible (no reenvía el resto de la sección) — usar
// siempre para el toggle de mostrar/ocultar en vez de updateSection.
const setSectionVisibility = async (sectionId, isVisible, modificationUser) => {
    try {
        const response = await api.put(`/classroom/section/${sectionId}/visibility`, { isVisible, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteSection = async (sectionId) => {
    try {
        const response = await api.delete(`/classroom/section/${sectionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Recursos. view: 'teacher' (default, ve todo) | 'student' (solo visibles)
const getResources = async (sectionId, view = 'teacher') => {
    try {
        const response = await api.get(`/classroom/section/${sectionId}/resources?view=${view}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getResource = async (resourceId) => {
    try {
        const response = await api.get(`/classroom/resource/${resourceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createResource = async (resourceData) => {
    try {
        const response = await api.post(`/classroom/resource`, resourceData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateResource = async (resourceData) => {
    try {
        const response = await api.put(`/classroom/resource`, resourceData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Cambia únicamente isVisible (no reenvía el resto del recurso) — usar
// siempre para el toggle de mostrar/ocultar en vez de updateResource.
const setResourceVisibility = async (resourceId, isVisible, modificationUser) => {
    try {
        const response = await api.put(`/classroom/resource/${resourceId}/visibility`, { isVisible, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteResource = async (resourceId) => {
    try {
        const response = await api.delete(`/classroom/resource/${resourceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Videos embebidos
const getVideos = async (classroomId) => {
    try {
        const response = await api.get(`/classroom/${classroomId}/videos`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getVideo = async (videoId) => {
    try {
        const response = await api.get(`/classroom/video/${videoId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createVideo = async (videoData) => {
    try {
        const response = await api.post(`/classroom/video`, videoData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateVideo = async (videoData) => {
    try {
        const response = await api.put(`/classroom/video`, videoData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteVideo = async (videoId) => {
    try {
        const response = await api.delete(`/classroom/video/${videoId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    getClassroomByAcademicSetting,
    getClassroom,
    createClassroom,
    updateClassroom,
    deleteClassroom,
    getIntervals,
    getInterval,
    createInterval,
    updateInterval,
    setIntervalVisibility,
    deleteInterval,
    getSections,
    getSection,
    createSection,
    updateSection,
    setSectionVisibility,
    deleteSection,
    getResources,
    getResource,
    createResource,
    updateResource,
    setResourceVisibility,
    deleteResource,
    getVideos,
    getVideo,
    createVideo,
    updateVideo,
    deleteVideo
};
